// 메신저(MM) iframe 에 주입하는 '읽음 N 라벨 자리' CSS — 긴 글 마지막 줄·블록이 «읽음 N» 라벨과 겹치지 않게 한다.
// 원인: EmbedPage drawReadLabels 가 라벨(button.gw-read-badge)을 글 오른쪽 아래 구석에 절대배치로 띄우는데,
//    본문은 그 자리를 비워 두지 않아 마지막 줄(코드·목록·인용·링크 미리보기 포함)이 오른쪽 끝까지 차면 라벨이 겹친다.
// 라벨 위치는 그대로 둔다(오른쪽 위는 MM 호버 메뉴가 덮어 클릭이 안 된다) — 본문 끝에 라벨 자리를 예약한다.
//    ① 마지막 블록 맨 끝에 빈 inline-block(64px × 1px)을 붙인다 → 마지막 줄이 꽉 차면 그 자리가 다음 줄로 내려가 라벨이 빈 자리에 앉는다.
//    ② 링크 미리보기(.post__embed-container)는 오른쪽 안쪽 여백 64px — 미리보기 안 그림·글자가 라벨 밑으로 안 들어간다.
// 🔴 두 규칙 모두 라벨 유무와 무관하다(:has(.gw-read-badge) 금지) — 라벨은 400ms 뒤·API 응답 뒤에 늦게 붙고 목록은
//    가상 목록이라 스크롤마다 다시 그려진다 → 라벨 유무로 본문 모양을 바꾸면 붙는 순간 글이 다시 줄바꿈되며 튄다.
// 🔴 64px = «읽음 1000» 라벨 폭(실측 58.4px) + 여유 — 읽은 수는 채널 멤버 기준이라 큰 채널에선 세 자리 이상이 된다.
// 🔴 라벨은 id 가 post_ 로 시작하는 가운데 채널 글에만 붙는다 → [id^="post_"] 로 가운데 목록만 겨냥한다(스레드 RHS 는 rhsPost_).
//    시스템 글(.post--system)은 라벨이 없어 뺀다. hr 로 끝나는 글은 구분선 높이가 커질 수 있어 뺀다(:not(hr)).
// 🔴 `> :last-child` 여야 한다 — `p:last-child` 꼴은 마지막 자식이 div.post-code·ul·blockquote 인 글을 못 덮는다.
export const MM_READ_BADGE_STYLE_ID = 'gw-mm-read-badge-css';

const POST = '.post[id^="post_"]:not(.post--system)';

export const MM_READ_BADGE_CSS = [
  // ① 마지막 블록 끝 라벨 자리(64px) — 문단이면 마지막 줄 끝, 목록·코드·표·인용이면 그 블록 안 맨 끝.
  `${POST} .post-message__text > :last-child:not(hr)::after{content:"";display:inline-block;width:64px;height:1px}`,
  // ② 링크 미리보기 오른쪽 64px — 라벨이 미리보기 상자의 오른쪽 여백에 앉는다.
  `${POST} .post__embed-container{padding-right:64px !important}`,
].join('');

// style#gw-mm-read-badge-css 를 head 에 '1개만' 유지한다. 폴링 루프(50ms×120)+onLoad 가 반복
// 호출하므로 멱등이 필수 — 이미 있으면 새로 만들지 않고 내용이 달라졌을 때만 갱신한다.
// doc·head 가 없으면(로드 중 문서) 조용히 no-op — applyMmStickerOrderCss 와 같은 형태.
export function applyMmReadBadgeCss(doc) {
  if (!doc || !doc.head) return;
  const found = doc.getElementById(MM_READ_BADGE_STYLE_ID);
  if (found) {
    if (found.textContent !== MM_READ_BADGE_CSS) found.textContent = MM_READ_BADGE_CSS;
    return;
  }
  const st = doc.createElement('style');
  st.id = MM_READ_BADGE_STYLE_ID;
  st.textContent = MM_READ_BADGE_CSS;
  doc.head.appendChild(st);
}
